import { type WalletClient, type TransactionRequest, encodeFunctionData } from "viem";
import type { TransactionHash } from "@/types";
import { gatewayV1Abi } from "@/abi";
import { getGatewayContractAddress } from "@/config";
import { estimateContractTransactionGas, writeContractTransaction } from "@/utils";

/**
 * Prepares a claim transaction
 */
export const prepareClaimTransaction = async (walletClient: WalletClient): Promise<TransactionRequest> => {
    if (!walletClient.account) {
        throw new Error("Wallet account is not available");
    }

    if (!walletClient.chain?.id) {
        throw new Error("Chain ID is not available");
    }

    const contractAddress = getGatewayContractAddress(walletClient.chain.id);

    return {
        to: contractAddress,
        data: encodeFunctionData({
            abi: gatewayV1Abi,
            functionName: "claimRedemption",
            args: [],
        }),
    };
};

/**
 * Executes a claim transaction
 */
export const gatewayClaimTransaction = async (walletClient: WalletClient): Promise<TransactionHash> => {
    const txRequest = await prepareClaimTransaction(walletClient);
    const hash = await writeContractTransaction(walletClient, txRequest);
    return hash as TransactionHash;
};

/**
 * Estimates gas for a claim transaction
 */
export const estimateClaimTransactionGas = async (walletClient: WalletClient): Promise<bigint> => {
    if (!walletClient.account) {
        throw new Error("Wallet account is not available");
    }

    const txRequest = await prepareClaimTransaction(walletClient);
    return estimateContractTransactionGas(walletClient, txRequest);
};
